const HOST_NAME = process.env.NEXT_PUBLIC_BASE_URL;

export const ENDPOINTS = {
  benefitsById: (id: number | string) =>
    HOST_NAME + `unauthorized/organisation/${id}/widget`
};
